module.exports = __webpack_public_path__ + "63e21f2d1e1b9d3200a134acdfbd7c92.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/crossblk.png
// module id = uFfh
// module chunks = 0